import { TimeRange } from '@app/core/range';

/**
 * Returns true when segment coverage does not span the full user-requested range.
 */
export function hasPartialSegmentCoverage(userRange: TimeRange, segmentsRange: TimeRange): boolean {
  return segmentsRange.from > userRange.from || segmentsRange.to < userRange.to;
}
